angular.module('natgeo').controller('SplashMenuScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ScreenView', 'UserProgress', 'SoundEngine', 'CommonFunctions',
function SplashMenuScreen($scope, element, ScreenFactory, manager, container, ScreenView, UserProgress, SoundEngine, CommonFunctions)
{
	var screen = ScreenFactory( 'splash_menu', element );
	
  screen.signs = screen.view.find('.signs');
  screen.rewards = screen.view.find('.rewards');

  screen.firsts = {
    level1: 'level1_splash',
    level2: 'level2_splash',
    level3: 'level3_splash',
    level4: 'level4_splash',
    level5: 'level5_splash'
  };

  screen.transitions = {
    level3: 'loading_level3',
    level4: 'loading_level4',
    level5: 'loading_level5'
  };

  screen.once('introBefore', function()
  {
    anim8.save('menuMessageBotIntro', {
      keyframe: {
        '0': {
          translate: -20,
          opacity: 0,
          scale: 0.6
        },
        '50': {
          opacity: 1
        },
        '100': {
          translate: 0,
          scale: 1.0
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('fadeInHalf', {
      keyframe: {
        from: {
          opacity: 0
        },
        to: {
          opacity: 0.5
        }
      }
    });

    anim8.save('fadeToHalf', {
      keyframe: {
        from: {
          opacity: true
        },
        to: {
          opacity: 0.5
        }
      }
    });

    anim8.save('fadeInHalfFull', {
      keyframe: {
        from: {
          opacity: 0.5
        },
        to: {
          opacity: 1.0
        }
      }
    });

    anim8.save('fadeOutHalf', {
      keyframe: {
        from: {
          opacity: true
        },
        to: {
          opacity: 0
        }
      }
    });

    anim8.save('fadeOutHalfAlmost', {
      keyframe: {
        from: {
          opacity: 0.5
        },
        to: {
          opacity: 0.1
        }
      }
    });

    anim8.save('menuLevel1Intro', {
      keyframe: {
        '0': {
          translate: {x:0, y:-100}
        },
        '100': {
          translate: 0
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel2Intro', {
      keyframe: {
        '0': {
          translate: {x:0, y:-100},
          easing: 'linear'
        },
        '50': {
          translate: {x:-50, y:-50},
          easing: 'linear'
        },
        '100': {
          translate: 0
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel3Intro', {
      keyframe: {
        '0': {
          translate: {x:0, y:-100}
        },
        '100': {
          translate: 0
        }
      },
      units: {
        translate: '%'
      }
    }, {
      teasing: 'ease'
    });

    anim8.save('menuLevel4Intro', {
      keyframe: {
        '0': {
          translate: {x:0, y:-100},
          easing: 'linear'
        },
        '50': {
          translate: {x:25, y:-50},
          easing: 'linear'
        },
        '100': {
          translate: 0
        }
      },
      units: {
        translate: '%'
      }
    }, {
      teasing: 'ease'
    });

    anim8.save('menuLevel5Intro', {
      keyframe: {
        '0': {
          translate: {x:-50, y:-100}
        },
        '100': {
          translate: 0
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel1Show', { // {80,-90} (167x281) -> {110,-70}
      keyframe: {
        '0': {
          translate: 0 
        },
        '50': {
          translate: {x: -5, y: 3.56}
        },
        '100': {
          translate: {x: 17.96, y: 7.12}
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel2Show', { // {180,-40} (174x288) -> {110,-110}
      keyframe: {
        '0': {
          translate: 0 
        },
        '100': {
          translate: {x: -41.72, y: -21.31}
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel3Show', { // {300,-120} (153,234) -> {290,-130}
      keyframe: {
        '0': {
          translate: 0 
        },
        '100': {
          translate: {x: -6.54, y: -4.27}
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel4Show', { // {0,0} (0,0) -> {0,0}
      keyframe: {
        '0': {
          translate: 0 
        },
        '70': {
          translate: {x: 19, y: -24}
        },
        '100': {
          translate: {x: 11, y: -22}
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('menuLevel5Show', { // {0,0} (0,0) -> {0,0}
      keyframe: {
        '0': {
          translate: 0 
        },
        '50': {
          translate: {x: -30, y: -10}
        },
        '100': {
          translate: {x: -55, y: 0}
        }
      },
      units: {
        translate: '%'
      }
    });

    anim8.save('highlightLevel', {
      keyframe: {
        from: {
          opacity: 0.2,
        },
        to: {
          opacity: 1.0
        }
      }
    });

    anim8.save('cardIn', {
      keyframe: {
        from: {
          translateY: 0,
          scale: 1
        },
        to: {
          translateY: -10,
          scale: 0.7
        }
      },
      initial: {
        origin: 'center top'
      },
      units: {
        translateY: '%'
      }
    });

    anim8.save('splashLevel2RobotIntro', {
      keyframe: {
        from: {
          translate: {x:100, y:-50},
          scale: 0.8,
          opacity: 0
        },
        to: {
          translate: 0,
          scale: 1,
          opacity: 1
        }
      }
    });

    anim8.save('splashLevel3BeeIntro', {
      keyframe: {
        '0,100': {
          translateY: 0
        },
        '40': {
          translateY: 10
        }
      },
      units: {
        translateY: '%'
      }
    }, {
      repeat: Number.POSITIVE_INFINITY
    });

    anim8.save('splashLevel4Sub1Intro', {
      keyframe: {
        '0': {
          opacity: 0,
          translateX: 0,
          translateY: 0,
          scale: 0.8
        },
        '10': {
          opacity: 0.5,
          translateX: -50,
          translateY: -10,
          scale: 0.9
        },
        '30': {
          opacity: 0.4,
          translateX: -125,
          translateY: 10,
          scale: 0.9
        },
        '40': {
          opacity: 0,
          translateX: -150,
          translateY: 0,
          scale: 0.8
        },
        '50': {
          opacity: 0,
          translateX: 25,
          translateY: 10,
          scale: 0.5
        },
        '70': {
          translateY: -10,
        },
        '90': {
          opacity: 1,
          translateX: -125,
          translateY: 10,
        },
        '100': {
          opacity: 0,
          translateX: -150,
          translateY: 0,
          scale: 0.6
        }
      },
      units: {
        translateX: '%',
        translateY: '%'
      }
    }, {
      easing: 'linear'
    });

    anim8.save('splashLevel4Sub2Intro', {
      keyframe: {
        '0': {
          opacity: 0,
          translateX: 0,
          translateY: 0,
          scale: 1.0
        },
        '10': {
          opacity: 1,
          translateX: -50,
          translateY: -10,
          scale: 0.9
        },
        '30': {
          opacity: 1,
          translateX: -100,
          translateY: 10,
          scale: 0.7
        },
        '40': {
          opacity: 0,
          translateX: -125,
          translateY: 0,
          scale: 0.6
        },
        '50': {
          opacity: 0,
          translateX: 0,
          translateY: 10,
          scale: 1.0
        },
        '70': {
          translateY: -10,
        },
        '90': {
          opacity: 0.3,
          translateX: -100,
          translateY: 10,
        },
        '100': {
          opacity: 0,
          translateX: -125,
          translateY: 0,
          scale: 0.6
        }
      },
      units: {
        translateX: '%',
        translateY: '%'
      }
    }, {
      easing: 'linear'
    });

    anim8.save('splashLevel4Sub3Intro', {
      keyframe: {
        '0': {
          opacity: 0,
          translateX: 0,
          translateY: 0,
          scale: 1.0
        },
        '10': {
          opacity: 0.1,
          translateX: -50,
          translateY: -10,
          scale: 0.9
        },
        '30': {
          opacity: 0.3,
          translateX: -140,
          translateY: 10,
          scale: 0.7
        },
        '40': {
          opacity: 0,
          translateX: -175,
          translateY: 0,
          scale: 0.6
        },
        '50': {
          opacity: 0,
          translateX: 25,
          translateY: 10,
          scale: 0.6
        },
        '70': {
          translateY: -10,
        },
        '90': {
          opacity: 0.9,
          translateX: -150,
          translateY: 10,
        },
        '100': {
          opacity: 0,
          translateX: -175,
          translateY: 0,
          scale: 0.6
        }
      },
      units: {
        translateX: '%',
        translateY: '%'
      }
    }, {
      easing: 'linear'
    });

    anim8.save('splashLevel5RobotIntro', {
      keyframe: {
        '0': {
          opacity: 0,
          translate: 0,
          scale: 1
        },
        '10': {
          opacity: 1,
          translate: 0,
          scale: 1
        },
        '55': {
          opacity: 1
        },
        '100': {
          opacity: 0,
          translate: {x: 10, y: -50},
          scale: 0.2
        }
      },
      units: {
        translate: '%'
      }
    }, {
      easing: 'linear',
      teasing: 'linear'
    });


  });

  screen.on('introBefore', function()
  {
    screen.signs.removeClass('hidden');
    screen._messageBot.removeClass('hidden');
    screen._hint.removeClass('hidden');
    screen._kiosk.removeClass('hidden');

    screen.updateRewards();

    if ( screen.currentPopupName )
    {
      screen.view.find( screen.currentPopupName ).addClass('hidden');
    }

    screen.currentSign = null;
    screen.currentSignAnimation = null;
    screen.currentPopupName = null;

    screen.updateHint();
  });

  // Sign Noise
  screen.on('introBegin', function()
  {
    SoundEngine.play( 'menu-transition', {delay:1000} );
  });

  // Highlight Signs
  screen.on('introEnd', function()
  {
    screen.updateHighlights();
  });

  screen.borderToBlue = function()
  {
    screen._border
      .animators()
      .play({
        keyframe: {
          from: {
            borderColor: '#FFD800'
          },
          to: {
            borderColor: '#007DC7'
          }
        }
      })
    ;
  };

  screen.borderToYellow = function()
  {
    screen._border
      .animators()
      .play({
        keyframe: {
          from: {
            borderColor: '#007DC7'
          },
          to: {
            borderColor: '#FFD800'
          }
        }
      })
    ;
  };

  screen.updateHint = function()
  {
    if (UserProgress.Level1 && UserProgress.Level2 && UserProgress.Level3 && UserProgress.Level4 && UserProgress.Level5)
    {
      screen._hint.html( '' );
    }
    else if (UserProgress.Level1 && UserProgress.Level2)
    {
      screen._hint.html( '(Hint: Now try one of the challenges: Robotic Bees, Ocean Cleanup or Tunnel Explorer!)' );
    }
    else if (UserProgress.Level1)
    {
      screen._hint.html( '(Hint: Now build your first robot.)' );
    }
    else
    {
      screen._hint.html( '(Hint: Start with your orientation.)' );
    }
  };

  screen.updateHighlights = function(dontHighlight)
  {
    if (UserProgress.Level1 === 0 && !dontHighlight)
    {
      screen._sign1Image.play('highlight infinite');
      screen._sign2Image.stopIt().restore();
    }
    else if (UserProgress.Level2 === 0 && !dontHighlight)
    {
      screen._sign1Image.stopIt().restore();
      screen._sign2Image.play('highlight infinite'); 
    }
    else
    {
      screen._sign1Image.stopIt().restore();
      screen._sign2Image.stopIt().restore();
    }
  };

  screen.updateRewards = function()
  {
    function updateReward(reward, outline, on)
    {
      if ( on )
      {
        if ( reward.hasClass('hidden') )
        {
          screen.introduceMany( reward, 'fadeIn ~0.5s' );
          screen.outroduceMany( outline, 'fadeOut' );
        }
      }
      else
      {
        if ( !reward.hasClass('hidden') )
        {
          screen.introduceMany( outline, 'fadeIn ~0.5s' );
          screen.outroduceMany( reward, 'fadeOut' );
        }
      }
    }

    updateReward( screen._reward1, screen._reward1Outline, UserProgress.Level1 );
    updateReward( screen._reward2, screen._reward2Outline, UserProgress.Level2 );
    updateReward( screen._reward3, screen._reward3Outline, UserProgress.Level3 );
    updateReward( screen._reward4, screen._reward4Outline, UserProgress.Level4 );
    updateReward( screen._reward5, screen._reward5Outline, UserProgress.Level5 );
  };

  $scope.tryShowLevel = function(sign, signAnimation, popupName, rewardName)
  {
    if ( screen.currentSign === sign )
    {
      return $scope.hideLevel();
    }

    screen.trySign = sign;
    screen.trySignAnimation = signAnimation;
    screen.tryPopupName = popupName;
    screen.tryRewardName = rewardName;

    if ( !UserProgress.Level1 && sign !== 'sign1' )
    {
      $scope.prompt( 'level1Dialog' );
    }
    else if ( UserProgress.Level1 && !UserProgress.Level2 && sign !== 'sign2' && sign !== 'sign1' )
    {
      $scope.prompt( 'level2Dialog' );
    }
    else
    {
      $scope.showLevel( sign, signAnimation, popupName, rewardName );
    }
  };

  $scope.prompt = (function(){

    var helper = CommonFunctions.help( screen, undefined, '' );

    return function( screenName ) {

      if ( screenName ) {
        screen.borderToBlue();
      } else {
        screen.borderToYellow();
      }

      helper.apply( CommonFunctions, arguments );

    };

  })();

  $scope.completeTry = function()
  {
    $scope.showLevel( screen.trySign, screen.trySignAnimation, screen.tryPopupName, screen.tryRewardName );
  };

  $scope.showLevel = function(sign, signAnimation, popupName, rewardName)
  {
    if ( screen.currentSign === sign )
    {
      return $scope.hideLevel();
    }

    SoundEngine.play( 'menu-select' );

    var signSprite = screen.sprite( sign );
    signSprite.play( signAnimation );

    var rewardSprite = screen.sprite( rewardName );
    var rewardSpriteOutline = screen.sprite( rewardName + 'Outline' );
    rewardSpriteOutline.play( 'fadeInHalfFull' );

    screen._popup.removeClass('hidden');
    screen.introduce( 'popupBack', 'zoomIn ~0.5s' );
    screen.outroduce( 'messageBot', 'menuMessageBotIntro ease-reverse 2s' );
    screen.outroduce( 'hint', 'fadeOut' );
    screen.outroduce( 'kiosk', 'fadeOutLeft' );

    screen.view.find( popupName )
      .removeClass('hidden')
      .restore()
      .dataPlay('show')
      .applyInitialState()
    ;

    screen.signs.not( signSprite ).dataPlay( 'outro' );
    screen.rewards.not( rewardSprite ).not( rewardSpriteOutline ).play( 'fadeOutHalfAlmost' );

    screen.borderToBlue();

    screen.updateHighlights(true);

    screen.currentSign = sign;
    screen.currentSignAnimation = signAnimation;
    screen.currentPopupName = popupName;
  };

  $scope.hideLevel = function()
  {
    var signSprite = screen.sprite( screen.currentSign );
    signSprite.play( screen.currentSignAnimation + ' ~0s ease-reverse' );

    screen.outroduce( 'popupBack', 'zoomOut ~0.5s' );
    screen.introduce( 'messageBot', 'menuMessageBotIntro 2s ~1s' );
    screen.introduce( 'hint', 'fadeIn ~1s' );
    screen.introduce( 'kiosk', 'fadeInLeft' );

    screen.outroduceMany( screen.view.find( screen.currentPopupName ), 'fadeOut ~0.7s 1s' );
    screen.signs.not( signSprite ).dataPlay( 'show' );

    screen.rewards.play( 'fadeToHalf' );

    screen.borderToYellow();

    screen.updateHighlights();

    screen.currentSign = null;
    screen.currentSignAnimation = null;
    screen.currentPopupName = null;
  };

  $scope.selectLevel = function(levelName)
  {
    var signSprite = screen.sprite( screen.currentSign );
    signSprite.play( 'fadeOut' );

    screen.outroduce( 'popup', 'fadeOut', function()
    {
      screen.signs.addClass('hidden');

      ScreenView.change( levelName, screen.firsts[ levelName ], true, undefined, screen.transitions[ levelName ] );
    });
  };

  $scope.passcode = '';
  $scope.getPasscode = UserProgress.getPasscode;

  $scope.loadPasscode = function()
  {
    var success = UserProgress.setPasscode( $scope.passcode );

    screen.view.find('.passcodeLevels').css({
      opacity: 0.2
    });

    screen._card
      .animators()
      .play('cardIn')
      .once('finished', function()
      {
        if ( !success )
        {
          screen.introduce( 'invalid', 'fadeIn 0.1s' );

          SoundEngine.play( 'fail-bump' );
        }
        else
        {
          UserProgress.savePasscode();

          if (UserProgress.Level1) screen._passcodeLevel1.play('highlightLevel');
          if (UserProgress.Level2) screen._passcodeLevel2.play('highlightLevel');
          if (UserProgress.Level3) screen._passcodeLevel3.play('highlightLevel');
          if (UserProgress.Level4) screen._passcodeLevel4.play('highlightLevel');
          if (UserProgress.Level5) screen._passcodeLevel5.play('highlightLevel');

          SoundEngine.play( 'passcode-redeem' );

          screen.updateRewards();
          screen.updateHighlights();
          screen.updateHint();
        }

        setTimeout(function()
        {
          screen.outroduce( 'invalid', 'fadeOut 1s' );
          screen._card.play( 'cardIn ease-backwards' );

        }, 4000);
      })
    ;
  };

  $scope.openPasscode = function()
  {
    screen._passcodeDialog.css('visibility', 'visible'); // work around
    screen.introduce( 'passcodeDialog', 'slideInLeft' );

    screen._card.restore();
    screen.borderToBlue();

    $scope.passcode = '';
  };

  $scope.closePasscode = function()
  {
    screen.outroduce( 'passcodeDialog', 'slideOutLeft' );
    screen.borderToYellow();    
  };

}]);